import AddToCartButton from './add-to-cart-button'

export default AddToCartButton
